import { cn } from '@/shared/lib/utils'

function Block({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-2xl bg-muted/70', className)} />
}

// Esqueleto que imita a shape real da tela (abas + stats + cards), em vez de um
// texto "Carregando…". Requisito de estado de loading do implement-frontend.
export function MyDataSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <Block className="h-10 w-48" />
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <Block key={i} className="h-20" />
        ))}
      </div>
      <Block className="h-72" />
      <Block className="h-40" />
      <Block className="h-40" />
    </div>
  )
}
